import React from "react";

import { Note } from "./styles";
import { PriceNoteProps } from "./types";

/**
 * "Price last updated …", with the provider's market close as optional hover context. Shared so
 * the two timestamps cannot be swapped on one surface and not another.
 *
 * Surfaces restyle it with `styled(PriceNote)` rather than re-implementing it.
 */
export const PriceNote: React.FC<PriceNoteProps> = ({
  priceUpdated,
  className,
}) => {
  if (!priceUpdated) {
    return null;
  }

  // Surfaces that ellipsise this line (the holdings table's price column) leave
  // a truncated sentence with no way back to it, and the richer market-close
  // title only exists when both timestamps arrived. Falling back to the line's
  // own text keeps every variant readable on hover.
  const title = priceUpdated.title ?? priceUpdated.text;

  return (
    <Note className={className} title={title}>
      {priceUpdated.text}
    </Note>
  );
};
